// 常见问题
<template>
  <div class="cjwt width1200" role="tablist">
<!--    <div class="item">
      <p class="title">动态HTTP代理隧道常见问题</p>
      <div class="item-list">
        <div class="collapse-ans">
          本页面提供关于动态HTTP代理隧道的一些常见问题的解答，如果您在使用过程中遇到问题，可以参阅。此外，您也可以在相关技术支持群里寻求帮助。
        </div>
      </div>
    </div>-->
    <div class="item" v-for="(item, index) in cjwtList" :key="index">
      <p class="title">{{ item.title }}</p>
      <div class="item-list">
        <div
          v-for="(accordion, accordionIndex) in item.data"
          :key="accordionIndex"
        >
          <div
            class="collapse-title d-flex d-flex-aic d-flex-jc-sb"
            :class="tabs == `${index}-${accordionIndex}` ? 'active' : ''"
            @click="collapseChange(index, accordionIndex)"
          >
            <span>{{ accordion.req }}</span>
            <img
              :src="
                require(tabs == `${index}-${accordionIndex}`
                  ? '@/assets/images/icon12.png'
                  : '@/assets/images/icon11.png')
              "
              alt=""
            />
          </div>
          <div
            class="collapse-ans"
            :style="{
              display: tabs == `${index}-${accordionIndex}` ? 'block' : 'none',
            }"
          >
            {{ accordion.ans }}
            <!--{{ (tabs, `${index}-${accordionIndex}`) }}-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: "0-0",
      cjwtList: [
        {
          title: "功能相关问题",
          data: [
            {
              req: "1.IP能使用多久？",
              ans: "在购买的周期内都能正常使用",
            },
            {
              req: "2.是否能切换IP？",
              ans: "暂时不支持切换IP，可以选择重新下单购买",
            },
            {
              req: "3.交付形式",
              ans: "由于各地市资源紧张，需要下单购买要和客服联系沟通具体需求。资源统一线下交付",
            },
          ],
        },
        // {
        //   title: "IP池相关问题",
        //   data: [
        //     {
        //       req: "池子里的代理IP都是在网上采集的免费代理吗？",
        //       ans: "1",
        //     },
        //     {
        //       req: "总池子多少IP？",
        //       ans: "1",
        //     },
        //     {
        //       req: "地区分布如何？",
        //       ans: "1",
        //     },
        //   ],
        // },
        // {
        //   title: "购买相关问题",
        //   data: [
        //     {
        //       req: "带宽或者每秒请求数能够在默认套餐基础上额外增加吗？",
        //       ans: "1",
        //     },
        //     {
        //       req: "可以免费测试吗？",
        //       ans: "2",
        //     },
        //     {
        //       req: "是否可以开具发票？",
        //       ans: "3",
        //     },
        //     {
        //       req: "是否可以签订合同？",
        //       ans: "4",
        //     },
        //   ],
        // },
      ],
    };
  },
  methods: {
    collapseChange(index, accordionIndex) {
      this.tabs = `${index}-${accordionIndex}`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/cjwt.less";
</style>
